export default "__VITE_ASSET__BknvdqYS__"